export default __webpack_public_path__ + "static/media/ico_checkbox_empty_gray.7328e510.svg";